import React from 'react';
import FormItemEditorRender from './FormItemEditorRender';
import FormItemDecimalDisplay from '../display/FormItemDecimalDisplay';
import StringUtil from '../../utils/StringUtil';
import CommonUtil from '../../utils/CommonUtil';
import {CmdUpdateShowDecimalStore} from '../../stores/CmdTypeStore';
require('../../styles/FormItemRender.css');
export default class FormItemDecimalRender extends FormItemEditorRender
{
	constructor(props) {
		super(props);

		this.unsubcribeCmdUpdateControlVisibleStore = 
		CmdUpdateShowDecimalStore.listen(this.onCmdUpdateShowDecimal.bind(this));
	}

	onCmdUpdateShowDecimal(name,_value,moduleInstanceId){
		if(name == StringUtil.convertToEachFirstUpperCase(this.props.dataField).replace(".","_"))
		{
			this.state['_cmdDisplayDecimal']=_value;	
			if(!window.doUpformItemShowDecimalValueMap){
				window.doUpformItemShowDecimalValueMap={};
				window.doUpformItemShowDecimalValueMap[name]=_value;
			}else{
				window.doUpformItemShowDecimalValueMap[name]=_value;
			}
			this.setState({});
		}
	}
	
	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;

		let parms = {};

		if(this.props.displayStyle)
		{
			let _displayStyle = this.props.displayStyle;
			if(_displayStyle.IsPercent == true)
			{
				parms.type = "percent";
			}
			else if(_displayStyle.CurrencyPrefix)
			{
				parms.type = "prefix";
				parms.prefix = _displayStyle.CurrencyPrefix;
			}
			else
			{
				parms.type = "normal";
			}
		}
		let sname = StringUtil.convertToEachFirstUpperCase(this.props.dataField).replace(".","_")
		if(window.doUpformItemShowDecimalValueMap && window.doUpformItemShowDecimalValueMap[sname]){
			_value = FormItemDecimalDisplay.getDisplayText(_value,this.props.showZero,window.doUpformItemShowDecimalValueMap[sname],this.props.thousandSeperator,parms);
		}else{
			_value = FormItemDecimalDisplay.getDisplayText(_value,this.props.showZero,this.props.showDecimals,this.props.thousandSeperator,parms);
		}

		return _value;
	}

	render()
	{
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		let _display = this.forLookup?"none":(this.props.group == undefined?"none":(this.props.group
			.isCurrentDataFieldModified(this.props.rowData,this.props.dataField)?"block":"none"));

		let rowStyles = this.getRowStyles();
		let _style = {padding:"3px"};
		let _displayStyle = this.props.displayStyle;
		if(_displayStyle && _displayStyle.Color)_style.color = _displayStyle.Color;
		if(this.props.cssStyle)
		{
			Object.assign(_style,this.props.cssStyle);
		}
		if(_display == "block")_style.backgroundColor = "#f8e8b7";
		_style.textAlign = this.props.textAlign.toLowerCase();

		let clientStyle = CommonUtil.getClientLayerRowStyles(window.formModuleInstance,null,"getDataGridStyle_"+this.props.gridXml.name,[this.props.rowData,this.props.dataField]);
		
		if(clientStyle)
		{
			_style = Object.assign(_style,clientStyle);
		}

		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+StringUtil.toColorStyleString(rowStyle.color);
							//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.backgroundColor != -1)
						_style.backgroundColor = "#"+StringUtil.toColorStyleString(rowStyle.backgroundColor);
							//rowStyle.backgroundColor.toString(16);
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+StringUtil.toColorStyleString(colStyle.color);
							//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.backgroundColor != -1)
						_style.backgroundColor = "#"+StringUtil.toColorStyleString(colStyle.backgroundColor);
							//colStyle.backgroundColor.toString(16);
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}
		let _clsName = "gongqi_render_select";
		if(_style.backgroundColor)_clsName+=" gongqi_render_back";
		if(_display == "block")_clsName+=" gongqi_render_version0";
		return(
			<div className={_clsName} ref={ node => this.componentLabel = node } style={_style}>
				{_value}
				<i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
			</div>
			
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemDecimalRender.js